@let depositBonusAvailability = depositBonusAvailability$ | async;

<header>
  <h1 translate="profile.title.verification"></h1>
  <btn
    [link]="true"
    (action)="promptSkip()"
    buttonText="common.btn.later"
    data-e2e-element="verify-later.button"
  ></btn>
</header>
<card-wrapper [noPadding]="true">
  <div class="wrapper">
    <h2 translate="verification.routing.full"></h2>
    <p translate="verification-route.full.requirement"></p>
    <ul>
      <li>
        <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
        <span translate="verification-route.full.benefit-1"></span>
      </li>
      <li>
        <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
        <span translate="verification-route.full.benefit-2"></span>
      </li>
      <li>
        <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
        <span translate="verification-route.full.benefit-3"></span>
      </li>
      <li>
        <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
        <span translate="verification-route.full.benefit-4"></span>
      </li>
      @if (depositBonusAvailability?.bonusIsAvailable) {
        <li>
          <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
          <span translate="verification-route.full.benefit-5"></span>
        </li>
      }
    </ul>
    <btn
      *ngrxLet="idRejected$; let rejected"
      [loading]="rejected === null"
      [buttonText]="rejected ? 'common.label.try-again' : 'verification-route.full.proceed.button'"
      routerLink="../identity"
    ></btn>
  </div>
</card-wrapper>
<card-wrapper [noPadding]="true">
  <div class="wrapper">
    <h2 translate="verification.routing.express"></h2>
    <p translate="verification-route.express.requirement"></p>
    <ul>
      <li>
        <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
        <span translate="verification-route.express.benefit-1"></span>
      </li>
      <li>
        <svg-icon-sprite src="./assets/img/icons/sprite.svg#check"></svg-icon-sprite>
        <span translate="verification-route.express.benefit-2"></span>
      </li>
    </ul>
    <btn
      *ngrxLet="idRejected$; let rejected"
      [loading]="rejected === null"
      [buttonText]="rejected ? 'verification-route.full.proceed.button' : 'verification-route.express.continue.button'"
      routerLink="../express"
      [blueBorder]="true"
    ></btn>
  </div>
</card-wrapper>
